import React from "react";
import { observer } from "mobx-react";
import { ShowcaseWorkflowStateViewStore } from "../../store";
import { ShowcaseWorkflowStateViewForm } from "./ShowcaseWorkflowStateViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type ShowcaseWorkflowStateViewProps = {
  showcaseWorkflowStateViewStore: ShowcaseWorkflowStateViewStore;
};

export const ShowcaseWorkflowStateView: React.FC<ShowcaseWorkflowStateViewProps> =
  observer(({ showcaseWorkflowStateViewStore }) => {
    return (
      <div>
        <ShowcaseWorkflowStateViewForm
          name_es={showcaseWorkflowStateViewStore.name_esValue}
          name_en={showcaseWorkflowStateViewStore.name_enValue}
          name_pt={showcaseWorkflowStateViewStore.name_ptValue}
          onPrint={(handlePrint: () => void) =>
            showcaseWorkflowStateViewStore.printShowcaseWorkflowState(
              handlePrint
            )
          }
          onCancel={() =>
            showcaseWorkflowStateViewStore.cancelShowcaseWorkflowState()
          }
          onEdit={
            showcaseWorkflowStateViewStore.isEditEnabled
              ? () => showcaseWorkflowStateViewStore.editShowcaseWorkflowState()
              : undefined
          }
        />
        <ErrorDialog
          open={showcaseWorkflowStateViewStore.errorDialogOpened}
          title={showcaseWorkflowStateViewStore.errorTitle}
          description={showcaseWorkflowStateViewStore.errorDescription}
          onClose={() => showcaseWorkflowStateViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
